const toStr = (value: unknown): string | null =>
  typeof value === 'string' ? value : null;

const toNormalizedMessage = (value: unknown): string | null => {
  const message = toStr(value);
  return message ? message.toLowerCase() : null;
};

const includesAny = (value: string, checks: readonly string[]): boolean =>
  checks.some((check) => value.includes(check));

export { includesAny, toNormalizedMessage, toStr };
